{
  "en": {
    "tools_meta": {
      "ai_chat_prefix": "Chat with AI",
      "ai_converters_prefix": "AI for Media Creation",
      "ai_document_qas_prefix": "PDF Chat",
      "ai_feedbacks_prefix": "Grading Assistant",
      "ai_images_prefix": "Image Generator",
      "ai_mini_tools_prefix": "Prompt Lab",
      "ai_assistants_prefix": "AI Assistants",
      "ai_personas_prefix": "Character Chat",
      "audio_recorder_prefix": "Audio Recorder",
      "file_sharing_prefix": "File Sharing",
      "link_shortener_prefix": "URL Shortener",
      "pinboard_prefix": "Pinboards",
      "pupil_feedback_prefix": "AI for Feedback",
      "qrcodes_prefix": "QR Code Generator",
      "school_class_prefix": "Shared Spaces",
      "screen_recorder_prefix": "Screen Recorder",
      "surveys_prefix": "Surveys",
      "teaching_board_prefix": "Teaching Boards",
      "text_editor_prefix": "Text Editor",
      "title": "AI Tools, PD Courses, & Teaching Materials",
      "video_recorder_prefix": "Video Recorder",
      "website_prefix": "Websites",
      "word_clouds_prefix": "Word Clouds",
      "worksheet_prefix": "Worksheet",
      "to_teach_import_prefix": "ToTeach Import"
    }
  }
}
